// @ts-nocheck — mixin methods are composed onto BackendService at runtime; instance API is typed via adminBackendServiceInterface.d.ts.
import type {
  ClientExceptionEvent,
  ClientExceptionEventDetail,
  ClientExceptionGroup,
  ClientExceptionSource,
  ClientExceptionStatus,
} from '../../models/ClientException';

// The "Client exceptions" tab (backend permission CanViewClientExceptions).
export const adminBackendServiceClientExceptionMixin = {
  listClientExceptions(params: {
    status?: ClientExceptionStatus | 'all';
    source?: ClientExceptionSource;
    limit?: number;
    offset?: number;
  }): Promise<{ groups: ClientExceptionGroup[]; total: number }> {
    const query = new URLSearchParams();
    if (params.status) query.set('status', params.status);
    if (params.source) query.set('source', params.source);
    query.set('limit', String(params.limit ?? 25));
    query.set('offset', String(params.offset ?? 0));
    return this.authApiGetAuthed(
      `admin/client-exceptions?${query.toString()}`,
      'Network error while loading client exceptions',
      (json) => ({ groups: json?.groups ?? [], total: json?.total ?? 0 }),
    );
  },

  getClientException(
    groupId: string,
  ): Promise<{ group: ClientExceptionGroup; events: ClientExceptionEvent[] }> {
    return this.authApiGetAuthed(
      `admin/client-exceptions/${encodeURIComponent(groupId)}`,
      'Network error while loading the client exception',
      (json) => ({ group: json?.group, events: json?.events ?? [] }),
    );
  },

  getClientExceptionEvent(eventId: string): Promise<ClientExceptionEventDetail> {
    return this.authApiGetAuthed(
      `admin/client-exceptions/events/${encodeURIComponent(eventId)}`,
      'Network error while loading the event',
      (json) => ({ event: json?.event, detail: json?.detail ?? null }),
    );
  },

  setClientExceptionStatus(
    groupId: string,
    status: ClientExceptionStatus,
    reason?: string,
  ): Promise<ClientExceptionGroup> {
    return this.authApiMutateAuthed(
      `admin/client-exceptions/${encodeURIComponent(groupId)}`,
      'PATCH',
      { status, reason },
      (json) => json?.group as ClientExceptionGroup,
    );
  },
};
